export const profileTypes = {
  LANDLORD: 'landlord',
  MANAGER: 'manager',
  TENANT: 'tenant',
  GUARANTOR: 'guarantor',
  CONTRACTOR: 'contractor',
  ERROR: 'error',
};

export const tenancyAgreementStatusTypes = {
  awaitingSignatures: 'awaitingSignatures',
  notCreated: 'notCreated',
  signed: 'signed',
  error: 'error',
};

export const tenancyAgreementStatusMap = {
  [tenancyAgreementStatusTypes.awaitingSignatures]: 'Awaiting signatures',
  [tenancyAgreementStatusTypes.notCreated]: 'Not created',
  [tenancyAgreementStatusTypes.signed]: 'Signed',
  [tenancyAgreementStatusTypes.error]: 'Error',
};

export const tenancyDepositStatusTypes = {
  error: 'error',
  unregistered: 'unregistered',
  inRegistration: 'inRegistration',
  registeredNotPaid: 'registeredNotPaid',
  protected: 'protected',
};

export const verificationStatusTypes = {
  VERIFIED: 'verified',
  PENDING: 'pending',
  REJECTED: 'rejected',
  NOT_COMPLETED: 'notCompleted',
};

export const depositStatusMap = {
  error: 'ERROR',
  awaitingPayment: 'AWAITING PAYMENT',
  unregistered: 'DEPOSIT PROTECTION',
  registeredNotPaid: 'TO DO',
  protected: 'PROTECTED',
};

export const paymentTypes = {
  RENT: 'tenantRent',
  DEPOSIT: 'tenantDeposit',
  LANDLORD_DEPOSIT: 'landlordDeposit',
  LANDLORD_SUBSCRIPTION: 'landlordSubscription',
};

export const paymentsTypesMap = {
  [paymentTypes.RENT]: 'Rent standing order',
  [paymentTypes.DEPOSIT]: 'Deposit order',
  [paymentTypes.LANDLORD_DEPOSIT]: 'Landlord deposit order',
};

export const paymentFrequencyTypes = {
  single: 'single',
  monthly: 'monthly',
};

export const noticeTypes = {
  ADMIN: 'admin',
  MESSAGING: 'messaging',
  PAYMENTS: 'payments',
  TENANCY: 'tenancy',
};

export const verifyEmailTypes = {
  login: 'login',
  register: 'createAccount',
};

export const verificationResultTypes = {
  authenticated: 'authenticated',
  invalid: 'invalid',
  expired: 'expired',
  error: 'error',
};

export const proprietorTypes = {
  company: 'company',
  soleTrader: 'soleTrader',
};

export const proprietorTypesMap = {
  [proprietorTypes.company]: 'Company',
  [proprietorTypes.soleTrader]: 'Sole trader',
};

export const OwnershipTypes = {
  companyOwned: 'companyOwned',
  companyMortgaged: 'companyMortgaged',
  soleOwned: 'soleOwned',
  soleMortgaged: 'soleMortgaged',
};

export const OwnershipTypesMap = {
  [OwnershipTypes.soleOwned]: 'Owned',
  [OwnershipTypes.soleMortgaged]: 'Mortgaged',
  [OwnershipTypes.companyOwned]: 'Company Owned',
  [OwnershipTypes.companyMortgaged]: 'Company Mortgaged',
};

export const SubscriptionStatusTypes = {
  active: 'active',
  cancelled: 'cancelled',
  unpaid: 'unpaid',
  freeTrial: 'freeTrial',
};

export const SubscriptionStatusTypesMap = {
  [SubscriptionStatusTypes.active]: 'Active',
  [SubscriptionStatusTypes.cancelled]: 'Cancelled',
  [SubscriptionStatusTypes.unpaid]: 'Unpaid',
  [SubscriptionStatusTypes.freeTrial]: 'Free Trial',
};

export const SubscriptionProductTypes = {
  propertyManagement: 'propertyManagement',
};

export const TenancyStatusTypes = {
  active: 'active',
  ended: 'ended',
  future: 'future',
  terminated: 'terminated',
};
